import './stories-section.scss';
import recall from '../../assets/scripts/loadMore';

export default () => {
	recall( '#load-more', '.article--item' );
};
